import { defineMessages } from 'react-intl';

export const scope = 'app.components.StyledSelect';

export default defineMessages({
  noOptionsMessage: {
    defaultMessage: 'No options available',
    id: `${scope}.noOptionsMessage`,
  },
  placeholder: {
    defaultMessage: 'Please select...',
    id: `${scope}.placeholder`,
  },
});
